export default "__VITE_ASSET__BUH9hgMt__"